import { makeCn } from "pfm-core";
import { CLASSNAME_PREFIX } from "@/constants";

export const cn = makeCn(CLASSNAME_PREFIX);
